import { cB as o, cE as r, c as e, cM as n, cNotM as a } from "../../../_utils/cssr/index.js";
const l = o("input", `
 max-width: 100%;
 cursor: text;
 line-height: 1.5;
 z-index: auto;
 outline: none;
 box-sizing: border-box;
 position: relative;
 display: inline-flex;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color .3s var(--n-bezier);
 font-size: var(--n-font-size);
 font-weight: var(--n-font-weight);
 --n-padding-vertical: calc((var(--n-height) - 1.5 * var(--n-font-size)) / 2);
`, [
  // common
  r("input, textarea", `
 overflow: hidden;
 flex-grow: 1;
 position: relative;
 `),
  r("input-el, textarea-el, input-mirror, textarea-mirror, separator, placeholder", `
 box-sizing: border-box;
 font-size: inherit;
 line-height: 1.5;
 font-family: inherit;
 border: none;
 outline: none;
 background-color: #0000;
 text-align: inherit;
 transition:
 -webkit-text-fill-color .3s var(--n-bezier),
 caret-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 `),
  r("input-el, textarea-el", `
 -webkit-appearance: none;
 scrollbar-width: none;
 width: 100%;
 min-width: 0;
 text-decoration-color: var(--n-text-decoration-color);
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 background-color: transparent;
 `, [e("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), e("&::placeholder", `
 color: #0000;
 -webkit-text-fill-color: transparent !important;
 `), e("&:-webkit-autofill ~", [r("placeholder", "display: none;")])]),
  n("round", [a("textarea", "border-radius: calc(var(--n-height) / 2);")]),
  r("placeholder", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: hidden;
 color: var(--n-placeholder-color);
 `, [e("span", `
 width: 100%;
 display: inline-block;
 `)]),
  n("textarea", [r("placeholder", "overflow: visible;")]),
  a("autosize", "width: 100%;"),
  n("autosize", [r("textarea-el, input-el", `
 position: absolute;
 top: 0;
 left: 0;
 height: 100%;
 `)]),
  // input
  o("input-wrapper", `
 overflow: hidden;
 display: inline-flex;
 flex-grow: 1;
 position: relative;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 `),
  r("input-mirror", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre;
 pointer-events: none;
 `),
  r("input-el", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [e("&[type=password]::-ms-reveal", "display: none;"), e("+", [r("placeholder", `
 display: flex;
 align-items: center; 
 `)])]),
  a("textarea", [r("placeholder", "white-space: nowrap;")]),
  r("eye", `
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `),
  // textarea
  n("textarea", "width: 100%;", [o("input-word-count", `
 position: absolute;
 right: var(--n-padding-right);
 bottom: var(--n-padding-vertical);
 `), n("resizable", [o("input-wrapper", `
 resize: vertical;
 min-height: var(--n-height);
 `)]), r("textarea-el, textarea-mirror, placeholder", `
 height: 100%;
 padding-left: 0;
 padding-right: 0;
 padding-top: var(--n-padding-vertical);
 padding-bottom: var(--n-padding-vertical);
 word-break: break-word;
 display: inline-block;
 vertical-align: bottom;
 box-sizing: border-box;
 line-height: var(--n-line-height-textarea);
 margin: 0;
 resize: none;
 white-space: pre-wrap;
 scroll-padding-block-end: var(--n-padding-vertical);
 `), r("textarea-mirror", `
 width: 100%;
 pointer-events: none;
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre-wrap;
 overflow-wrap: break-word;
 `)]),
  // pair
  n("pair", [r("input-el, placeholder", "text-align: center;"), r("separator", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 white-space: nowrap;
 `, [o("icon", `
 color: var(--n-icon-color);
 `), o("base-icon", `
 color: var(--n-icon-color);
 `)])]),
  n("disabled", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [r("border", "border: var(--n-border-disabled);"), r("input-el, textarea-el", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 text-decoration-color: var(--n-text-color-disabled);
 `), r("placeholder", "color: var(--n-placeholder-color-disabled);"), r("separator", "color: var(--n-text-color-disabled);", [o("icon", `
 color: var(--n-icon-color-disabled);
 `), o("base-icon", `
 color: var(--n-icon-color-disabled);
 `)]), o("input-word-count", `
 color: var(--n-count-text-color-disabled);
 `), r("suffix, prefix", "color: var(--n-text-color-disabled);", [o("icon", `
 color: var(--n-icon-color-disabled);
 `), o("internal-icon", `
 color: var(--n-icon-color-disabled);
 `)])]),
  a("disabled", [r("eye", `
 color: var(--n-icon-color);
 cursor: pointer;
 `, [e("&:hover", `
 color: var(--n-icon-color-hover);
 `), e("&:active", `
 color: var(--n-icon-color-pressed);
 `)]), e("&:hover", [r("state-border", "border: var(--n-border-hover);")]), n("focus", "background-color: var(--n-color-focus);", [r("state-border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]),
  r("border, state-border", `
 box-sizing: border-box;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: inherit;
 border: var(--n-border);
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `),
  r("state-border", `
 border-color: #0000;
 z-index: 1;
 `),
  r("prefix", "margin-right: 4px;"),
  r("suffix", `
 margin-left: 4px;
 `),
  r("suffix, prefix", `
 transition: color .3s var(--n-bezier);
 flex-wrap: nowrap;
 flex-shrink: 0;
 line-height: var(--n-height);
 white-space: nowrap;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 color: var(--n-suffix-text-color);
 `, [o("base-loading", `
 font-size: var(--n-icon-size);
 margin: 0 2px;
 color: var(--n-loading-color);
 `), o("base-clear", `
 font-size: var(--n-icon-size);
 `, [r("placeholder", [o("base-icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)])]), e(">", [o("icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)]), o("base-icon", `
 font-size: var(--n-icon-size);
 `)]),
  o("input-word-count", `
 pointer-events: none;
 line-height: 1.5;
 font-size: .85em;
 color: var(--n-count-text-color);
 transition: color .3s var(--n-bezier);
 margin-left: 4px;
 font-variant: tabular-nums;
 `),
  ["warning", "error"].map((i) => n(`${i}-status`, [a("disabled", [o("base-loading", `
 color: var(--n-loading-color-${i})
 `), r("input-el, textarea-el", `
 caret-color: var(--n-caret-color-${i});
 `), r("state-border", `
 border: var(--n-border-${i});
 `), e("&:hover", [r("state-border", `
 border: var(--n-border-hover-${i});
 `)]), e("&:focus", `
 background-color: var(--n-color-focus-${i});
 `, [r("state-border", `
 box-shadow: var(--n-box-shadow-focus-${i});
 border: var(--n-border-focus-${i});
 `)]), n("focus", `
 background-color: var(--n-color-focus-${i});
 `, [r("state-border", `
 box-shadow: var(--n-box-shadow-focus-${i});
 border: var(--n-border-focus-${i});
 `)])])]))
]), c = o("input", [n("disabled", [r("input-el, textarea-el", `
 -webkit-text-fill-color: var(--n-text-color-disabled);
 `)])]);
export {
  l as default,
  c as safariStyle
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input/src/styles/input.cssr.js
// module id = 1660
// module chunks = 41